import { ALIGNMENT } from 'prose-core'
import { useAlignButtonToggle } from 'common/Prose/Toolbar/hooks/useAlignButtonToggle'
import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const AlignJustifyButton = observer(() => {
  const { active, handleClick } = useAlignButtonToggle(ALIGNMENT.Justify)

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.AlignJustify} />}
      label="Justified"
      ariaLabel="Align justified"
      active={active}
      handleClick={handleClick}
    />
  )
})
